/* eslint-disable */
import React from 'react'
import { KTColors } from '../../Constants/KTColors'
import { heightPercentageToDP, widthPercentageToDP } from '../../../Utils/ResponsiveScreen'
import { fonts } from '../../Constants/theme'
import MDEditor from '@uiw/react-md-editor'
import AwsConfig from '../../../Config/AwsConfig'
import DynamicButtonView from '../DynamicButtonView'
import MultiBackgroundImages from '../MultiBackgroundImages'

const styles = {
  predivCardPoster: {
    height: heightPercentageToDP('35'),
    resizeMode: 'cover',
  },
  cardImageStyle: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  questionsContentPoster: {
    height: heightPercentageToDP('100'),
    resizeMode: 'cover',
  },
  explanationContainer: {
    paddingHorizontal: widthPercentageToDP('5%'),
    paddingVertical: heightPercentageToDP('3%'),
  },
  questionText: {
    textAlign: 'center',
    fontSize: heightPercentageToDP('2.8%'),
    fontWeight: 'bold',
    marginBottom: heightPercentageToDP('1%'),
  },
  scrolldivContainer: {
    paddingBottom: 150,
  },
  explanationText: {
    textAlign: 'justify',
    fontSize: heightPercentageToDP('2.2%'),
    color: KTColors.black50,
  },
  contentBottomStrip: {
    width: widthPercentageToDP('100%'),
    height: 40,
  },
  explanationCloseIcon: {
    position: 'absolute',
    top: heightPercentageToDP('-0.4%'),
    right: widthPercentageToDP('0%'),
  },
  cardCloseIcon: {
    position: 'absolute',
    top: heightPercentageToDP('6.3%'),
    right: widthPercentageToDP('8%'),
    zIndex: 99999,
    backgroundColor: KTColors.white70,
    borderRadius: 50,
    padding: 10,
  },
  contentMain: {
    height: heightPercentageToDP('37%'),
    backgroundColor: KTColors.white,
  },
  contentDescriptionMain: {
    paddingLeft: widthPercentageToDP('5%'),
    paddingRight: widthPercentageToDP('5%'),
    paddingTop: widthPercentageToDP('2%'),
    paddingBottom: widthPercentageToDP('2%'),
    backgroundColor: 'yellow',
    height: heightPercentageToDP('9%'),
    overflow: 'hidden',
  },
  contentDescriptionContainer: {
    paddingLeft: widthPercentageToDP('5%'),
    paddingRight: widthPercentageToDP('5%'),
    paddingTop: widthPercentageToDP('2%'),
    paddingBottom: widthPercentageToDP('2%'),
    overflow: 'hidden',
  },

  contentTitle: {
    color: KTColors.black,
    fontSize: heightPercentageToDP('2.6%'),
    fontWeight: 'bold',
    textAlign: 'center',
  },
  contentDescription: {
    color: KTColors.black,
    fontSize: heightPercentageToDP('2.2%'),
    textAlign: 'center',
  },
  htmlExplanationStyle: {
    marginRight: widthPercentageToDP('2%'),
    width: widthPercentageToDP('2%'),
    height: widthPercentageToDP('2%'),
    marginTop: widthPercentageToDP('2.3%'),
    borderRadius: 20,
    backgroundColor: KTColors.black50,
    color: KTColors.black50,
  },
  ellipseStyle: {
    // height: $font - size * $line - height * $lines - to - show,
  },
  copyRightStyle: {
    padding: widthPercentageToDP('1%'),
    borderRadius: widthPercentageToDP('1%'),
    position: 'absolute',
    left: widthPercentageToDP('5%'),
    flexDirection: 'row',
    maxWidth: widthPercentageToDP('54%'),
    backgroundColor: KTColors.black20,
  },
  urlstyle: {
    top: heightPercentageToDP('56%'),
    borderRadius: widthPercentageToDP('1%'),
    position: 'absolute',
    right: widthPercentageToDP('5%'),
    maxWidth: widthPercentageToDP('35%'),
    borderWidth: 1,
    borderColor: KTColors.white80,
    backgroundColor: KTColors.black20,
    padding: widthPercentageToDP('2.2%'),
    flexDirection: 'row',
  },
}

const ShortByteView = props => {
  const [dispShowMore, setDispShowMore] = React.useState(false)
  const [explanationModal, setExplanationModal] = React.useState(false)
  const [reload, setReload] = React.useState(false)
  const {
    showBottomLogo,
    content,
    contentType,
    contentLinkDetails,
    title,
    cardDescription,
    cardImages,
    coverStoryVideoURL,
    contentNewLinkDetails,
  } = props
  const fontFamilyStyle = fonts.fontFamilyMallanna
  const urlType = contentLinkDetails ? contentLinkDetails.urlType : ''
  const instagramLink = contentLinkDetails ? contentLinkDetails.instagramLink : ''
  const youtubeLink = contentLinkDetails ? contentLinkDetails.youtubeLink : ''
  const twitterLink = contentLinkDetails ? contentLinkDetails.twitterLink : ''
  const websiteLink = contentLinkDetails ? contentLinkDetails.websiteLink : ''

  let url = ''
  let linkText = ''
  let redirectUrlLogo = ''
  let urltype = ''

  const renderCoverStoryVideo = () => {
    let cdnurl = AwsConfig.cdn_url
    let uri = ''
    if (!uri && coverStoryVideoURL) {
      uri = coverStoryVideoURL
      if (uri && !uri.includes(cdnurl)) {
        uri = cdnurl + coverStoryVideoURL
      }
    }
    return (
      coverStoryVideoURLValidations() && (
        <div style={{ height: heightPercentageToDP('35'), backgroundColor: KTColors.black }}>
          <video width={widthPercentageToDP('100')} height={heightPercentageToDP('35')} controls>
            <source src={uri} type='video/mp4' />
          </video>
        </div>
      )
    )
  }

  const cardImagesValidation = () => {
    const cardImageAvailable = cardImages && cardImages[0]
    return cardImageAvailable
  }

  const coverStoryVideoURLValidations = () => {
    return coverStoryVideoURL != '' && coverStoryVideoURL != null && coverStoryVideoURL != undefined
  }

  if (contentLinkDetails && !props.contentNewLinkDetails) {
    const urltype = urlType && urlType.toLocaleLowerCase()
    switch (urltype) {
      case 'instagram':
        url = instagramLink
        redirectUrlLogo = 'dist/img/insta_less_size.png'
        linkText = 'Watch On'
        break
      case 'youtube':
        url = youtubeLink
        redirectUrlLogo = 'dist/img/youtube_logo_4.png'
        linkText = 'Watch On'
        break
      case 'twitter':
        url = twitterLink
        redirectUrlLogo = 'dist/img/twitter_logo.png'
        linkText = 'Watch On'
        break
      case 'website':
        url = websiteLink
        redirectUrlLogo = ''
        linkText = 'Visit Website'
        break
      default:
        url = ''
        redirectUrlLogo = ''
        linkText = ''
    }
  }

  const changeContentLinkUrlData = contentNewLinkDetails => {
    const {
      urlType,
      linkText,
      instagramLink,
      youtubeLink,
      twitterLink,
      playstoreLink,
      appstoreLink,
      trackerLink,
      httpsLink,
    } = contentNewLinkDetails
    let buttonText = ''
    let appLink = trackerLink ? trackerLink : playstoreLink
    urltype = urlType && urlType.toLocaleLowerCase()
    switch (urltype) {
      case 'instagramlink':
        url = instagramLink
        redirectUrlLogo = 'dist/img/insta_less_size.png'
        buttonText = linkText ? linkText : 'Watch On'
        return renderDefaultButton(url, buttonText, redirectUrlLogo)
      case 'youtubelink':
        url = youtubeLink
        redirectUrlLogo = 'dist/img/youtube_logo_4.png'
        buttonText = linkText ? linkText : 'Watch On'
        return renderDefaultButton(url, buttonText, redirectUrlLogo)
      case 'twitterlink':
        url = twitterLink
        redirectUrlLogo = 'dist/img/twitter_logo.png'
        buttonText = linkText ? linkText : 'Watch On'
        return renderDefaultButton(url, buttonText, redirectUrlLogo)
      case 'facebooklink':
        url = contentNewLinkDetails?.facebookLink
        redirectUrlLogo = ''
        buttonText = linkText ? linkText : 'Watch On'
        return renderDefaultButton(url, buttonText, redirectUrlLogo)
      case 'httpslink':
        url = httpsLink
        redirectUrlLogo = ''
        buttonText = linkText ? linkText : 'visit Website'
        return renderDefaultButton(url, buttonText, redirectUrlLogo)
      case 'storeLink':
        url = appLink
        buttonText = linkText ? linkText : 'Download'
        return renderDefaultButton(url, buttonText, '')

      case 'saavnlink':
        url = contentNewLinkDetails?.saavnLink
        buttonText = linkText ? linkText : 'Music'
        return renderDefaultButton(url, buttonText, '')
      case 'gaanalink':
        url = contentNewLinkDetails?.gaanaLink
        buttonText = linkText ? linkText : 'Music'
        return renderDefaultButton(url, buttonText, '')
      case 'page':
        url = 'url'
        redirectUrlLogo = ''
        buttonText = linkText
        return renderDefaultButton(url, buttonText, '')
      case 'people':
        url = 'url'
        redirectUrlLogo = ''
        buttonText = linkText
        return renderDefaultButton(url, buttonText, '')
      case 'collection':
        url = 'url'
        redirectUrlLogo = ''
        buttonText = linkText
        return renderDefaultButton(url, buttonText, '')
      case 'list':
        url = 'url'
        redirectUrlLogo = ''
        buttonText = linkText
        return renderDefaultButton(url, buttonText, '')
      case 'content':
        url = 'url'
        redirectUrlLogo = ''
        buttonText = linkText
        return renderDefaultButton(url, buttonText, '')
      case 'video':
        url = 'url'
        redirectUrlLogo = ''
        buttonText = linkText
        return renderDefaultButton(url, buttonText, '')

      default:
        return null
    }
  }

  const renderDynamicButton = () => {
    const isContnentNewLinkArray = Array.isArray(props.contentNewLinkDetails)
    return (
      isContnentNewLinkArray &&
      props.contentNewLinkDetails?.map(contentNewLinkDetails => {
        if (contentNewLinkDetails?.buttonPosition == 'custom') {
          return <DynamicButtonView contentNewLinkDetails={contentNewLinkDetails} />
        } else if (contentNewLinkDetails?.buttonPosition == 'default') {
          return changeContentLinkUrlData(contentNewLinkDetails)
        }
      })
    )
  }

  const renderDefaultButton = (url, linkText, redirectUrlLogo) => {
    return url ? (
      <div style={styles.urlstyle}>
        <a
          href={url}
          target='_blank'
          style={{
            color: KTColors.white,
          }}
        >
          {linkText}
        </a>
        {redirectUrlLogo ? (
          <img
            src={redirectUrlLogo}
            alt='User Avatar'
            style={{
              height: widthPercentageToDP('5%'),
              width: widthPercentageToDP('5%'),
              marginLeft: widthPercentageToDP('2%'),
            }}
          />
        ) : null}
      </div>
    ) : null
  }

  const cardImagesExists = cardImages && cardImages[0]
  const copyRightText = cardImagesExists ? cardImages[0].copyRightText : ''
  const cardImage = cardImagesExists
    ? cardImages[0].imageValue
      ? cardImages[0].imageValue
      : cardImages[0].image
    : ''
  let imageHeight = 65
  let descriptionHeight = 34.6
  let copyRightHeight = 34.6

  switch (props.shortByteTemplateType) {
    case 'Small':
      imageHeight = 65
      descriptionHeight = 20
      copyRightHeight = 60

      break
    case 'Medium':
      imageHeight = 55
      descriptionHeight = 30
      copyRightHeight = 50

      break
    case 'Large':
      imageHeight = 35
      descriptionHeight = 50
      copyRightHeight = 30

      break
    default:
      imageHeight = 65
      descriptionHeight = 20
      copyRightHeight = 60
      break
  }

  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {props.closeButton ? (
        <div
          style={styles.cardCloseIcon}
          onClick={() => {
            props.flipCard()
          }}
        >
          <p style={{ fontSize: widthPercentageToDP('5%'), fontWeight: 'bold' }}>X</p>
        </div>
      ) : null}
      {cardImagesValidation() && (
        <div
          style={{
            height: heightPercentageToDP(imageHeight),
            width: widthPercentageToDP('100%'),
            backgroundColor: KTColors.doveGray,
          }}
        >
          {/* <img
            src={cardImage}
            alt='User Avatar'
            style={{
              height: heightPercentageToDP('35%'),
              width: widthPercentageToDP('100%'),
            }}
          /> */}
          <MultiBackgroundImages
            style={{ overflow: 'hidden' }}
            images={props.cardImages}
            shortByteTemplateType={props.shortByteTemplateType}
            type={'ShortByte'}
          />
          {copyRightText ? (
            <div
              style={{
                ...styles.copyRightStyle,
                top: heightPercentageToDP(copyRightHeight),
              }}
            >
              <p
                style={{
                  fontSize: heightPercentageToDP('1.5%'),
                  color: KTColors.white,
                }}
              >
                {copyRightText}
              </p>
            </div>
          ) : null}
          {renderDefaultButton(url, linkText, redirectUrlLogo)}
        </div>
      )}
      {renderCoverStoryVideo()}
      {renderDynamicButton()}

      <div class='contentMain' style={styles.contentMain}>
        <div class='contentDescriptionMain' style={styles.contentDescriptionMain}>
          <div className='contenttitleContainer'>
            <p style={styles.contentTitle}>{title}</p>
          </div>
        </div>
        <div
          className='contentDescriptionContainer'
          style={{
            ...styles.contentDescriptionContainer,
            height: heightPercentageToDP(descriptionHeight),
          }}
        >
          <p style={styles.contentDescription}>{cardDescription}</p>
        </div>
      </div>
    </div>
  )
}

export default ShortByteView
